import React from 'react';

import { useIntl } from 'react-intl-next';

import CalendarIcon from '@atlaskit/icon/core/migration/calendar';
import PeopleIcon from '@atlaskit/icon/core/migration/people-group--people';
import PersonCircleIcon from '@atlaskit/icon/core/migration/person-avatar--person-circle';

import { type RuleType } from '../../../../types';

import messages from './messages';

export const RuleIcon = ({ type }: { type: RuleType['type'] }) => {
	const { formatMessage } = useIntl();

	return type === 'schedule' ? (
		<CalendarIcon
			color="currentColor"
			label={formatMessage(messages.scheduleLabel)}
			LEGACY_size="small"
		/>
	) : type === 'team' ? (
		<PeopleIcon
			color="currentColor"
			label={formatMessage(messages.teamLabel)}
			LEGACY_size="small"
		/>
	) : (
		<PersonCircleIcon
			color="currentColor"
			label={formatMessage(messages.userLabel)}
			LEGACY_size="small"
		/>
	);
};
